import { applyMiddleware, legacy_createStore as createStore } from 'redux';
import { withExtraArgument } from 'redux-thunk';

import { apiThunk } from '../actions';
import { rootReducer } from '../reducers';

const store = createStore(
	rootReducer,
	undefined,
	applyMiddleware(withExtraArgument(apiThunk))
);

export default store;
